// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"af96e0b0","579":"af96e0b0"}[chunkId] + ".chunk.css";
};